import { get, post, del } from '@api/request';
import { filter, get as getter, pick, map, isEmpty } from 'lodash';

export const fetchLoadStreams = async (baseUrl, authenticationToken) => {
  const url = `${baseUrl}/loads/synced-streams`;
  const { body } = await get(authenticationToken, url);
  return filter(body, v => getter(v, 'stream_type', 1) === 2 && isEmpty(v['removed_at']));
};

export const fetchProviders = async (baseUrl, authenticationToken) => {
  const url = `${baseUrl}/loads/synced-streams`;
  const { body } = await get(authenticationToken, url);
  const realList = filter(body, v => getter(v, 'is_fake') === false);
  return map(realList, v => pick(v, ['stream_id', 'company', 'dot_number']));
};

export const createCredentialsLoadStreams = async (
  baseUrl,
  authenticationToken,
  payload,
) => {
  const url = `${baseUrl}/loads/stream-credential`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteCredentialsLoadStreams = async (
  baseUrl,
  authenticationToken,
  payload,
) => {
  const stream_id = getter(payload, 'stream_id', '');
  const format_payload = { encrypted_credentials: '' };
  const url = `${baseUrl}/loads/stream-credential/${stream_id}/`;
  const { body } = await del(authenticationToken, url, format_payload);
  return body;
};
